module.exports = __webpack_public_path__ + "img/logo14.28264f41.jpg";